import React, { Suspense } from 'react'
import { Navigate, Route, Routes, useLocation } from 'react-router-dom'
import { CContainer, CSpinner } from '@coreui/react'
import routes from '../routes'

const AppContent = () => {
  let defaultpath = '/'
  const location = useLocation()
  return (
    <CContainer fluid className={`${location.pathname === '/' ? 'container-padding' : 'p-0'}`}>
      <Suspense
        fallback={
          <div className="loading-container">
            <CSpinner
              color="primary"
              className="d-flex justify-content-center align-items-center"
            />
          </div>
        }
      >
        <Routes>
          {routes.map((route, idx) => {
            return (
              route.element && (
                <Route
                  key={idx}
                  path={route.path}
                  exact={route.exact}
                  name={route.name}
                  element={<route.element />}
                />
              )
            )
          })}
          <Route path="/" element={<Navigate to={defaultpath} replace />} />
        </Routes>
      </Suspense>
    </CContainer>
  )
}

export default React.memo(AppContent)
